.flatpickr-calendar {
  opacity: 0;
  display: none;
  visibility: hidden;
  position: absolute;
  background: #fff;
  padding: 8px;
  min-width: 240px;
  max-width: 250px;
  box-shadow: var(--dropdown-box-shadow);
  color: #27272a;
  border-radius: 0.5rem;

}@media (max-width: 767px) {.flatpickr-calendar {
    position: fixed;
    inset: 0px !important;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 0px;
    border-width: 0px;
    width: 100%;
    max-width: 100%;
    height: 100vh;

  }

}

.flatpickr-calendar.open {
  opacity: 1;
  visibility: visible;
  display: inline-block;
  z-index: calc(var(--z-index-top) + 1);
}

.flatpickr-months {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

@media (max-width: 767px) {.flatpickr-months {
    margin-bottom: 0.75rem;

  }

}

.flatpickr-months .flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month {
    display: flex;
    padding: 6px;
    border-radius: 0.5rem;
  }

@media (min-width: 1024px) {.flatpickr-months .flatpickr-prev-month:hover, .flatpickr-months .flatpickr-next-month:hover {
    cursor: pointer;
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));

  }

}

.flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg {
      width: 1rem;
      height: 1rem;
    }

@media (max-width: 767px) {.flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg {
    height: 1.5rem;
    width: 1.5rem;

  }

}

.flatpickr-months .flatpickr-month {
    margin: 0 auto;
  }

.flatpickr-months .flatpickr-monthDropdown-months {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

}

.flatpickr-months .flatpickr-current-month {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

.flatpickr-months .cur-month {
  font-weight: 600;
    padding-left: 10px;

}

.flatpickr-months .numInput {
    width: 40px !important;
    border: 0;
    box-shadow: none;
    margin: 0 0 0 12px;
    padding: 0;
    -moz-appearance: textfield;
  }

.flatpickr-months .numInput:hover,
    .flatpickr-months .numInput:focus {
      box-shadow: none;
    }

.flatpickr-months .numInput:disabled {
      background: white;
    }

.flatpickr-months .numInput::-webkit-inner-spin-button,
    .flatpickr-months .numInput::-webkit-outer-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }

.flatpickr-weekdays {
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;

}

.flatpickr-weekdays .flatpickr-weekdaycontainer {
    display: flex;
    width: 100%;
  }

.flatpickr-weekdays .flatpickr-weekday {
    text-align: center;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #52525b;
    text-transform: uppercase;
    width: calc(100% / 7);
  }

.flatpickr-days .dayContainer {
    display: flex;
    flex-wrap: wrap;
  }

.flatpickr-days .flatpickr-day {
  width: 14.2857143%;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  font-weight: 600;

}

@media (max-width: 767px) {.flatpickr-days .flatpickr-day {
    font-size: 1rem;
    line-height: 1.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0px;
    padding-right: 0px;

  }

}

.flatpickr-days .flatpickr-day.today {
      position: relative;
    }

.flatpickr-days .flatpickr-day.today::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        border-top: 8px solid #2563eb;
        border-right: 0 solid transparent;
        border-bottom: 0 solid transparent;
        border-left: 8px solid transparent;
      }

.flatpickr-days .flatpickr-day:hover,
    .flatpickr-days .flatpickr-day:focus {
      background: #dbeafe;
      border-color: #dbeafe;
      cursor: pointer;
      outline: none;
    }

.flatpickr-days .flatpickr-day.selected {
      background: #2563eb;
      border-color: #2563eb;
      color: white;
    }

.flatpickr-days .flatpickr-day.selected.flatpickr-day.today::after {
          border-top-color: white;
        }

.flatpickr-days .flatpickr-day.flatpickr-disabled {
      background: #f4f4f5;
      border-color: #f4f4f5;
    }

.flatpickr-days .flatpickr-day.flatpickr-disabled:hover {
        cursor: not-allowed;
        background: #f4f4f5;
        border-color: #f4f4f5;
      }

.flatpickr-days .prevMonthDay,
  .flatpickr-days .nextMonthDay {
    color: #52525b;
  }

/*# sourceMappingURL=data:application/json;base64,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 */